import React from "react";

export default function Legal() {
  return (
    <div data-testid="legal-page" className="mx-auto max-w-3xl px-5 lg:px-10 py-16 prose prose-stone">
      <h1 className="font-display-black text-5xl sm:text-6xl mb-6">Mentions légales</h1>
      <h2 className="font-display text-2xl mt-8">Éditeur</h2>
      <p>Bon Sang Magazine — Média indépendant.</p>
      <p>Contact : bonsangmagazine@gmail.com</p>

      <h2 className="font-display text-2xl mt-8">Hébergement</h2>
      <p>Site hébergé chez nos partenaires d&apos;infrastructure.</p>

      <h2 className="font-display text-2xl mt-8">Propriété intellectuelle</h2>
      <p>
        L&apos;ensemble du contenu de ce site (textes, images, podcasts) est protégé par
        le droit d&apos;auteur. Toute reproduction sans autorisation est interdite.
      </p>

      <h2 className="font-display text-2xl mt-8">Données personnelles</h2>
      <p>
        Aucune donnée personnelle n&apos;est collectée à des fins commerciales.
        Pour toute demande RGPD, écrivez-nous : bonsangmagazine@gmail.com
      </p>
    </div>
  );
}
